import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import AnimatedBackground from './components/AnimatedBackground';
import RoadScrollIndicator from './components/RoadScrollIndicator';

// Page Components
import Hero from './components/Hero';
import SocialProof from './components/SocialProof';
import Benefits from './components/Benefits';
import BentoProductSection from './components/BentoProductSection';
import FeatureTracking from './sections/features/FeatureTracking';
import FeatureBilling from './sections/features/FeatureBilling';
import FeatureCompliance from './sections/features/FeatureCompliance';
import NarrativeBridge from './sections/narrative/NarrativeBridge';
import HowItWorks from './components/HowItWorks';
import Results from './components/Results';
import MobileApps from './components/MobileApps';
import CTA from './components/CTA';

// Page Routes
import About from './pages/About';
import Contact from './pages/Contact';
import Investors from './pages/Investors';
import Leadership from './pages/Leadership';
import SCMT from './pages/SCMT';
import EmployeeTransport from './pages/EmployeeTransport';
import Trucks from './pages/Trucks';
import Pricing from './pages/Pricing';
import PrivacyPolicy from './pages/PrivacyPolicy';

// Home Page Component
const Home: React.FC = () => {
  return (
    <>
      <AnimatedBackground />
      <RoadScrollIndicator />
      <Hero />
      <SocialProof />
      <BentoProductSection />
      <Benefits />
      <NarrativeBridge 
        title="Everything you need to run your fleet like a pro"
        description="From real-time tracking to automated billing—discover the tools that power India's smartest fleet operators."
      />
      <FeatureTracking />
      <FeatureBilling />
      <FeatureCompliance />
      <HowItWorks />
      <Results />
      <MobileApps />
      <CTA />
    </>
  );
};

// Main App Component
const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="contact" element={<Contact />} />
          <Route path="investors" element={<Investors />} />
          <Route path="leadership" element={<Leadership />} />
          <Route path="scmt" element={<SCMT />} />
          <Route path="employee-transport" element={<EmployeeTransport />} />
          <Route path="trucks" element={<Trucks />} />
          <Route path="pricing" element={<Pricing />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default App;
